module.exports = __webpack_public_path__ + "static/media/client-aul.c8582680.png";